import { render } from "./about.vue?vue&type=template&id=7b7e9de8&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=7b7e9de8&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/NM12r8skh/0/website/official-website-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7e9de8"]])

export default __exports__